import Vue from 'vue';

export const pluralize = (count: number, word: string, pluralForm?: string) => {
  return count !== 11 && count % 10 === 1 ? word : pluralForm || word + 's';
};

export const truncate = (word: string, length: number, omisson = '') => {
  if (!word) {
    return '';
  }
  if (length > word.length) {
    return word;
  }

  return `${word.substr(0, length).trim()}${omisson}`;
};

export const highlight = (string: string, search: string) => {
  const searchRE = new RegExp(`(${search})`, 'ig');
  return search ? string.replace(searchRE, `<em>$1</em>`) : string;
};

Vue.filter('pluralize', pluralize);
Vue.filter('truncate', truncate);
Vue.filter('highlight', highlight);
